export default __webpack_public_path__ + "static/media/loop.68126ddd.svg";